import { AddUpdateAssessmentViolationComponent } from "./add-update-assessment-violation.component";
export const AddUpdateAssessmentViolationModule = angular
    .module('addUpdateAssessmentViolation', [])
    .component(AddUpdateAssessmentViolationComponent.selector, AddUpdateAssessmentViolationComponent.component)
    .name;
//# sourceMappingURL=add-update-assessment-violation.module.js.map